import { IPromotionLogicInterface } from '@gongxigames/framework/promotions';

export type SingleSetPromotionChoice = 'accept' | 'reject';

export interface ISingleSetPromotionInterface extends IPromotionLogicInterface {
    setChoice(choice: SingleSetPromotionChoice, callback: () => void): void;
    end(): void;
}
